<template>
  <v-expansion-panels accordion class="mt-5" v-model="panel">
    <v-expansion-panel
      v-for="(pendampingan_ke, index) in Object.keys((meta && meta.pendampingan) || {})"
      :key="index"
      v-model="panel"
      @click="onChangePendampinganKe(pendampingan_ke)"
    >
      <v-expansion-panel-header class="px-0 py-1">
        <template v-slot:actions>
          <v-icon color="primary">
            $expand
          </v-icon>
        </template>
        <template v-slot:default="{ open }">
          <v-list>
            <v-list-item class="px-0">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-calendar</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0 px-1">
                <v-row>
                  <v-col cols="12" lg="9">
                    <div class="body-2 grey--text">Bulan Pelaksanaan</div>
                    <div class="body-1 black--text font-weight-medium">
                      {{ $getDeepObj(meta, `pendampingan.${pendampingan_ke}`) }}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-auto text-right info--text font-weight-medium">
                    <div v-if="open"> Tampilkan Ringkas <v-icon right>mdi-down</v-icon> </div>
                    <div v-else> Tampilkan Semua <v-icon right>mdi-down</v-icon> </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="yellow lighten-5">
        <v-list class="yellow lighten-5">
          <template v-if="listFsp.length">
            <v-list-item class="px-0" v-for="(fsp, fspId) in listFsp" :key="`${fspId}- ${pendampingan_ke}`">
              <v-list-item-avatar />
              <v-list-item-content class="pb-2">
                <v-divider v-if="fspId !== 0" class="mb-4" />
                <v-row>
                  <v-col cols="12" lg="5">
                    <div class="body-2 grey--text">
                      Nama Fasilitator
                    </div>
                    <div class="body-1 black--text font-weight-medium">
                      {{ $getDeepObj(fsp, 'ptk.nama') }}
                    </div>
                    <div> <strong>SIMPKB ID: </strong>{{ fsp.ptk_id }} </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div class="body-2 grey--text">
                      Status Laporan
                    </div>
                    <v-chip
                      :color="status[getStatusLaporan(fsp.psp_profil_id, pendampingan_ke)]['color']"
                      class="white--text"
                    >
                      {{ status[getStatusLaporan(fsp.psp_profil_id, pendampingan_ke)]['label'] }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-auto" v-if="akunInstansiId">
                    <div>
                      <v-btn
                        :disabled="!laporans[pendampingan_ke]"
                        class="text-capitalize"
                        depressed
                        color="primary"
                        @click="onViewLaporan(pendampingan_ke, fsp)"
                      >
                        <v-icon left>mdi-eye</v-icon> Lihat Laporan
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="3" v-else-if="$allow('psp-pelatih-ahli-koordinator-pa-laporan.update')">
                    <div class="body-2 grey--text">
                      Aksi
                    </div>
                    <v-btn
                      class="text-capitalize"
                      depressed
                      color="primary"
                      :disabled="
                        !meta.jadwal[pendampingan_ke] && isEditLaporan(fsp.psp_profil_id, pendampingan_ke) === 'empty'
                      "
                      @click="onEditLaporan(pendampingan_ke, fsp)"
                    >
                      <v-icon left>
                        {{
                          meta.jadwal[pendampingan_ke] && isEditLaporan(fsp.psp_profil_id, pendampingan_ke) !== false
                            ? 'mdi-pencil'
                            : 'mdi-eye'
                        }}
                      </v-icon>
                      {{
                        meta.jadwal[pendampingan_ke] && isEditLaporan(fsp.psp_profil_id, pendampingan_ke) !== false
                          ? 'Lengkapi'
                          : 'Lihat'
                      }}
                      Laporan
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-else>
            <div class="mt-4"><em class="grey--text">Tidak ada data Fasilitator yang ditemukan</em></div>
          </template>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'KoordinatorFspLaporanSekolah',
  props: {
    status: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    laporans: {
      type: Object,
      default: () => {},
    },
    laporansFsp: {
      type: Object,
      default: () => {},
    },
    form: {
      type: String,
      default: '',
    },
    akunInstansiId: {
      default: '',
    },
    pendampinganTahun: {
      type: [String, Number],
      default: 2022,
    },
  },
  data() {
    return {
      pendampinganKe: null,
      loaded: true,
      panel: null,
    };
  },
  computed: {
    listFsp() {
      const laporans = Object.values(this.laporansFsp || {}) || [];
      const laporanPaExist = laporans
        .filter((laporan) => laporan.psp_profil_pa)
        .map((laporan) => laporan.psp_profil_pa);

      let temp = [];
      let result = [];
      for (const pa of [...(this.meta.pa || []), ...laporanPaExist]) {
        if (!temp.includes(pa.psp_profil_id)) {
          result.push(pa);
          temp.push(pa.psp_profil_id);
        }
      }

      return result;
    },
  },
  methods: {
    reset() {
      this.panel = 0;
    },

    getStatusLaporan(pspProfilIdPa) {
      const laporanFsp = this.laporansFsp[pspProfilIdPa] || {};

      if (!this.$isObject(laporanFsp)) {
        return -1;
      }

      if (laporanFsp.is_terlaksana === 0) {
        return 2;
      }

      return laporanFsp.is_lengkap || -1;
    },

    isEditLaporan(pspProfilIdPa) {
      const laporanFsp = this.laporansFsp[pspProfilIdPa] || {};

      if (!this.$isObject(laporanFsp)) {
        return 'empty';
      }

      return laporanFsp.is_edit;
    },

    onChangePendampinganKe(pendampinganKe) {
      this.pendampinganKe = null;
      this.$emit('pendampingan', pendampinganKe);
    },

    onEditLaporan(pendampinganKe, fsp) {
      this.$emit('laporan', { pendampinganKe, fsp, form: this.form });
    },

    onViewLaporan(pendampinganKe, fsp) {
      this.$emit('laporan', { pendampinganKe, fsp, form: this.form, isPreview: true });
    },
  },
  watch: {
    'meta.pendampingan_ke': function(pendampinganKe) {
      this.pendampinganKe = pendampinganKe;
      this.loaded = true;
    },
  },
};
</script>

<style scoped></style>
